import { useEffect, useState } from "react";
import useMetriportToast from "./useMetriportToast";
// TODO: 2064 Will add to shared when its used by monorepo
import { getPatientFacilityMatches, PatientFacilityMatches } from "../../../api/patient-matches";
import { capture } from "../../../shared/capture";

type UseGetPatientMatches = {
  patientMatches: PatientFacilityMatches;
};

export function useGetPatientMatches({ patientId }: { patientId: string }): UseGetPatientMatches {
  const toast = useMetriportToast();
  const [patientMatches, setPatientMatches] = useState<PatientFacilityMatches>([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const matches = await getPatientFacilityMatches(patientId);
        setPatientMatches(matches);
      } catch (error) {
        const msg = "Error retrieving patient matches";
        toast.error({ title: msg });
        capture.message(msg, {
          extra: { context: `patient.matches`, patientId, error },
          level: "error",
        });
      }
    }

    fetchData();
  }, [patientId]);

  return { patientMatches };
}
